import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexCol,
  FlexRowCenterVertical,
  FlexColCenter,
} from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { __ } from 'react-i18n';
import {
  formatPriceToString,
  prop,
  round,
  formatPrice,
} from '../../../utilities';

interface Props {
  text: string;
  isMobile?: boolean;
  notAbsolute?: boolean;
  style?: any;
}

function SaleBubbleNew({ text, isMobile, notAbsolute, style }: Props) {
  let correctDiscount;
  if (text.includes('%') || text.includes('€')) {
    correctDiscount = text;
  } else {
    correctDiscount = round(parseFloat(text), 2);
  }

  return (
    <Wrapper style={style} notAbsolute={notAbsolute} isMobile={isMobile}>
      <InsideWrapper>{correctDiscount}</InsideWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexColCenter)<{
  isMobile?: boolean;
  notAbsolute?: boolean;
}>`
  /* background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  width: ${rem(70)};
  height: ${rem(70)};
  border-radius: 50%;
  position: ${({ notAbsolute }) => (notAbsolute ? 'initial' : 'absolute')};
  top: ${({ isMobile }) => (isMobile ? rem(-24) : rem(-24))};
  right: ${({ isMobile }) => (isMobile ? 0 : rem(-24))};
  cursor: initial;

  ${({ theme }) => theme.mediab.m760`
  `} */

  /* min-width: ${rem(70)};
  min-height: ${rem(70)};
  z-index: 1;
  border-radius: 50%;
  position: ${({ notAbsolute }) => (notAbsolute ? 'initial' : 'absolute')};
  top: ${({ isMobile }) => (isMobile ? rem(-24) : rem(-24))};
  right: ${({ isMobile }) => (isMobile ? 0 : rem(-24))};
  cursor: initial;
  color: #fff;
  display:inline-block; */

  min-width: ${rem(52)};
  min-height: ${rem(52)};
  position: ${({ notAbsolute }) => (notAbsolute ? 'initial' : 'absolute')};
  top: ${({ isMobile }) => (isMobile ? rem(-16) : rem(-32))};
  right: ${({ isMobile }) => (isMobile ? rem(-16) : rem(-32))};
  display: inline-block;
  border-radius: 50%;
  padding: ${rem(8)};
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  text-align: center;
  line-height: 1;
  box-sizing: content-box;
  white-space: nowrap;

  &:before {
    content: "";
    display: inline-block;
    vertical-align: middle;
    padding-top: 100%;
    height: 0;
  }
`;

// const InsideWrapper = styled.div`
//   padding: 60% 10%;
//   /* margin-top: -0.6em; */

//   &:after {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 120%;
//     padding-bottom: 120%;
//     background-color: ${({ theme }) => theme.colors.primary};
//     border-radius: 50%;
//     z-index: -1;
//   }
// `;

const InsideWrapper = styled.span`
  display: inline-block;
  vertical-align: middle;
`;

export { SaleBubbleNew };
